import APP from "../appConfig";

const exampleContractsUrl = "api/common/example-contracts";
const assignmentExampleContractsUrl = `${exampleContractsUrl}/assignment?type=:type&disclosed=:disclosed&retention=:retention&ipu=:ipu`

const getAssignmentExampleContractDownloadUrl = (params) => {
    return APP.DOMAIN + assignmentExampleContractsUrl
		.replace(":type", params.type)
		.replace(":disclosed", params.disclosed)
		.replace(":retention", params.retention)
		.replace(":ipu", params.ipu);
};

export const exampleContractsApi = {
    getAssignmentExampleContractDownloadUrl: getAssignmentExampleContractDownloadUrl
};